import PropTypes from 'prop-types';

const propType = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  identifierCode: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
};

export default { propType };
